const {VITE_WS_URL} = import.meta.env;

export const APP_VARS = {
  FE_VERSION: window.versionConfig.FE_VERSION ?? 'Unknown',
  WS_URL: VITE_WS_URL ?? `wss://${document.location.host}/api/v1/messages/streaming`,
  FEATURE_FLAGS: {
    ALL_PROMPTS: window.appConfig.FEATURE_FLAGS?.ALL_PROMPTS ?? false,
    VIDEO_AVATAR: window.appConfig.FEATURE_FLAGS?.VIDEO_AVATAR ?? false
  },
  LIVEKIT_URL: window.appConfig.LIVEKIT_URL,
  FIREBASE: window.appConfig.FIREBASE,
  SENTRY_DSN: window.appConfig.SENTRY_DSN ?? '',
  IS_DEV_ENV: ['localhost:3000', 'dev.malenia.hexen.ai'].includes(document.location.host)
};
